import { CertificateDictionaryModel } from "../../models/certificate.model";
import { BackendHttpService } from "../backendHttpService";

/**
 * Certificate Dictionary Service
 *
 * Pure read-only service for accessing certificate dictionary data.
 * This service is focused solely on retrieving dictionary information
 * and is designed to be used by both regular services and React Query hooks.
 *
 * For admin operations (create, update, delete), use CertificateService.
 */
export class CertificateDictionaryService extends BackendHttpService {
  // Cache for certificate dictionary
  private certificatesDictionaryCache: CertificateDictionaryModel[] | null =
    null;

  constructor() {
    super("dictionary/certificates");
  }

  /**
   * Get all certificates from dictionary
   * GET /dictionary/certificates
   */
  async getCertificatesDictionary(): Promise<CertificateDictionaryModel[]> {
    if (this.certificatesDictionaryCache) {
      return this.certificatesDictionaryCache;
    }

    try {
      this.certificatesDictionaryCache = await this.get<
        CertificateDictionaryModel[]
      >("");
      return this.certificatesDictionaryCache;
    } catch (error) {
      console.error("Error getting certificates dictionary:", error);
      throw error;
    }
  }

  /**
   * Clear the cached dictionary data
   * Used when dictionary is modified through admin operations
   */
  clearCache(): void {
    this.certificatesDictionaryCache = null;
  }
}

// Create and export a singleton instance for consistency
export const certificateDictionaryService = new CertificateDictionaryService();
